export default function SoloThunderIcon({ className }: { className?: string }) {
	return (
		// biome-ignore lint/a11y/noSvgWithoutTitle: <explanation>
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="30"
			height="30"
			viewBox="0 0 24 24"
			fill="none"
			className={className}
		>
			<rect width="24" height="24" rx="12" fill="#96FF43" />
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M12.3108 10.9578L16.5924 10.9663C16.9287 10.9667 17.116 11.332 16.9209 11.5858L16.9214 11.5863L9.78709 20.8405C9.52504 21.1813 8.9411 20.9342 9.06856 20.4937L10.6947 14.0348H6.40936C6.08413 14.0348 5.86368 13.6744 6.09704 13.3919L13.2146 4.1596C13.4767 3.8188 14.0604 4.06563 13.9334 4.50614L12.3108 10.9578Z"
				fill="black"
			/>
		</svg>
	);
}
